module.exports = __webpack_public_path__ + "assets/img/search_2_line.50088acb.svg";